/* Fathom V3 - Open Horizon : interactions
   - sticky header frosts on scroll
   - scroll-reveal with per-group stagger (IntersectionObserver)
   - magnetic primary buttons (fine pointers only)
   - re-initialises on shopify:section:load so the theme editor (add/remove
     blocks) never leaves freshly rendered elements stuck hidden.
   Degrades gracefully: without html.oh-anim everything is shown statically. */
(function () {
  var docEl = document.documentElement;
  var SEL = '.prod,.act,.post,.ig,.promobnr,.news,.band .step,.shead,.pcard,'
          + '.hero h1,.hero .lead,.hero .cta,.hero .meta';
  var inEditor = !!(window.Shopify && window.Shopify.designMode);
  var finePointer = !!(window.matchMedia && window.matchMedia('(pointer:fine)').matches);

  /* sticky header */
  var head = document.querySelector('.head');
  if (head) {
    var onScroll = function () { head.classList.toggle('scrolled', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* white header when it overlays a dark (media) hero; reverts when none */
  function ohDarkHero(){ docEl.classList.toggle('oh-dark-hero', !!document.querySelector('.hero--media')); }
  ohDarkHero();
  document.addEventListener('shopify:section:load', ohDarkHero);

  /* mobile menu drawer (hamburger) + search jump. Delegated on document so it
     keeps working after the header re-renders in the theme editor, and runs
     regardless of motion preference (the early return below is for animations only). */
  function ohClosest(t, sel){ return (t && t.closest) ? t.closest(sel) : null; }
  function ohDrawer(open){
    var d = document.querySelector('[data-oh-drawer]'); if (!d) return;
    if (open){ d.hidden = false; void d.offsetWidth; d.classList.add('show'); document.body.classList.add('oh-drawer-open'); }
    else { d.classList.remove('show'); document.body.classList.remove('oh-drawer-open');
      setTimeout(function(){ if (!d.classList.contains('show')) d.hidden = true; }, 320); }
    var b = document.querySelector('[data-oh-menu-open]'); if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  document.addEventListener('click', function (e){
    if (ohClosest(e.target, '[data-oh-menu-open]')) { e.preventDefault(); ohDrawer(true); return; }
    if (ohClosest(e.target, '[data-oh-menu-close]')) { e.preventDefault(); ohDrawer(false); return; }
    if (ohClosest(e.target, '[data-oh-search-jump]')) { e.preventDefault(); ohDrawer(true);
      var si = document.querySelector('[data-oh-drawer-search-input]'); if (si) setTimeout(function(){ si.focus(); }, 340); return; }
  });
  document.addEventListener('keydown', function (e){ if (e.key === 'Escape') ohDrawer(false); });

  /* scroll progress (--p, 0..1) drives the sunrise sky; the coordinate HUD drifts
     its lat/long and climbs in elevation as you travel down the page. */
  (function () {
    var geo = document.querySelector('[data-oh-geo]');
    var geoCo = geo && geo.querySelector('[data-oh-geo-co]');
    var geoEl = geo && geo.querySelector('[data-oh-geo-el]');
    var baseLat = 46.8531, baseLng = 121.7603;
    var ticking = false;
    function apply() {
      ticking = false;
      var max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      var p = window.scrollY / max; if (p < 0) p = 0; if (p > 1) p = 1;
      docEl.style.setProperty('--p', p.toFixed(4));
      if (geo) {
        if (geoCo) {
          var lat = baseLat + p * 0.42, lng = baseLng + p * 0.31;
          geoCo.textContent = lat.toFixed(4) + '\u00B0N \u00B7 ' + lng.toFixed(4) + '\u00B0W';
        }
        if (geoEl) { geoEl.textContent = 'ELEV ' + (Math.round(p * 124) * 10) + ' m'; }
        geo.classList.toggle('show', window.scrollY > 140);
      }
    }
    function onScrollP() { if (!ticking) { ticking = true; requestAnimationFrame(apply); } }
    window.addEventListener('scroll', onScrollP, { passive: true });
    window.addEventListener('resize', onScrollP, { passive: true });
    apply();
  })();

  /* no motion allowed -> everything is already visible via CSS, just wire header */
  if (!docEl.classList.contains('oh-anim')) return;

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }) : null;

  function setupReveal(root) {
    var els = Array.prototype.slice.call((root || document).querySelectorAll(SEL));
    if (!els.length) return;

    /* stagger siblings that share a parent */
    var groups = [];
    els.forEach(function (el) {
      if (el.dataset.ohReady) return;
      var p = el.parentNode, idx = 0, hit = false;
      for (var i = 0; i < groups.length; i++) { if (groups[i].p === p) { idx = ++groups[i].n; hit = true; break; } }
      if (!hit) groups.push({ p: p, n: 0 });
      el.style.transitionDelay = Math.min(idx * 60, 360) + 'ms';
    });

    els.forEach(function (el) {
      if (el.dataset.ohReady) return;
      el.dataset.ohReady = '1';
      /* In the theme editor reveal immediately so editing never hides content.
         On the live site use the observer (or reveal if unsupported). */
      if (inEditor || !io) { el.classList.add('in'); }
      else { io.observe(el); }
    });
  }

  function setupMagnetic(root) {
    if (!finePointer) return;
    Array.prototype.slice.call((root || document).querySelectorAll('.btn-coral')).forEach(function (b) {
      if (b.dataset.ohMag) return;
      b.dataset.ohMag = '1';
      b.addEventListener('mousemove', function (ev) {
        var r = b.getBoundingClientRect();
        var x = ev.clientX - r.left - r.width / 2;
        var y = ev.clientY - r.top - r.height / 2;
        b.style.transform = 'translate(' + (x * 0.18).toFixed(1) + 'px,' + (y * 0.28 - 1).toFixed(1) + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }

  /* pinned horizontal "expedition" scroll: pin the section, slide the track sideways */
  function setupHpin(root){
    Array.prototype.slice.call((root||document).querySelectorAll('[data-oh-hpin]')).forEach(function(sec){
      if (sec.dataset.hpinReady) return; sec.dataset.hpinReady = '1';
      var track = sec.querySelector('[data-oh-hpin-track]'), vp = sec.querySelector('.oh-hpin-vp');
      if (!track || !vp) return;
      var overflow = 0;
      function measure(){ overflow = Math.max(0, track.scrollWidth - vp.clientWidth); sec.style.height = (window.innerHeight + overflow) + 'px'; }
      function onScroll(){ var top = sec.getBoundingClientRect().top; var s = Math.min(Math.max(-top, 0), overflow); track.style.transform = 'translate3d(' + (-s) + 'px,0,0)'; }
      measure(); onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function(){ measure(); onScroll(); }, { passive: true });
      if ('ResizeObserver' in window){ try { new ResizeObserver(function(){ measure(); onScroll(); }).observe(track); } catch(e){} }
    });
  }

  /* image blur-up: fade images in as they load (placeholder -> crisp) */
  function setupImgFade(root){
    var imgs = (root||document).querySelectorAll('.prod img,.pcard img,.post img,.ig img,.hero img,.promobnr img,.news img');
    Array.prototype.slice.call(imgs).forEach(function(im){
      if (im.dataset.ohFade) return; im.dataset.ohFade = '1';
      im.classList.add('oh-fade');
      if (im.complete && im.naturalWidth > 0) { im.classList.add('loaded'); }
      else { im.addEventListener('load', function(){ im.classList.add('loaded'); });
             im.addEventListener('error', function(){ im.classList.add('loaded'); }); }
    });
  }

  function init(root) { setupReveal(root); setupMagnetic(root); setupHpin(root); setupImgFade(root); }

  init(document);

  /* Shopify theme editor: a section re-renders on block add/remove/reorder.
     Re-init so new elements are observed (or revealed) instead of stuck hidden. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target; while (el && el !== document) { if (el.dataset && !el.dataset.ohReady) { el.classList.add('in'); } el = el.parentNode; }
  });
})();
